import Xarrow from "react-xarrows";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualGenerator({ setTutorial }) {
  const renderTrigger = useArrowSync();

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("show-generator-2") && (
        <div className={`${styles["container"]} ${styles["container-6"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-6"
            className={`${styles["container__text"]} ${styles["container__text-1"]}`}>
            <p>Click here to generate your tests</p>
          </div>

          <Xarrow
            key={`arrow-4-${renderTrigger}`}
            start="tutorial-text-6"
            end="show-generator-2"
            color="#415B32"
            strokeWidth={3}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-6"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Almost done! This screen lets you tweak various generation options. By
              default, the <b>n-wise</b> generator is selected.
            </p>
            <p>
              To finish up, simply click the <b>GENERATE</b> button!
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualGenerator;
